export const OPENNED = 'Openned';
export const SIGNED = 'Signed';
export const CLOSED = 'Closed';
export const ARCHIVED = 'Archived';
export const CANCELED = 'Canceled';

export const LISTE_ETAT_CONTRAT_SIGNATURE = [
  { code: OPENNED, libelle: 'detailDevis.signature.contratEtatSignature.openned', filtre: true },
  { code: SIGNED, libelle: 'detailDevis.signature.contratEtatSignature.signed', filtre: false },
  { code: CLOSED, libelle: 'detailDevis.signature.contratEtatSignature.closed', filtre: true },
  { code: ARCHIVED, libelle: 'detailDevis.signature.contratEtatSignature.archived', filtre: true },
  { code: CANCELED, libelle: 'detailDevis.signature.contratEtatSignature.canceled', filtre: true },
];

export const DEVIS = 'Devis';
export const COMMANDE = 'Commande';

export const LISTE_REFERENCE_SIGNATURE = [
  { code: DEVIS, libelle: 'listeSignatureElectroniqueEncours.referenceSignature.devis' },
  { code: COMMANDE, libelle: 'listeSignatureElectroniqueEncours.referenceSignature.commande' },
];

export const EXPORT_EXCEL_SIGNATURE_ELECTRONIQUE = 'signatureelectronique';
export const TYPE_EDITION_SIGNATURE_ELECTRONIQUE = 'SignatureElectronique';
